<template>
    <div class="teams">
        <ul class="list">
            <li v-for="item in teamsList" :key="item.id" v-if="!item.hidden" @click="goMenu(item)">
                <span><img :src="require('@/assets/img/teams/teams.svg')" alt=""></span>
                <p :style="item.name.length > 6 ? 'font-size: 30px;width: 70%;margin-left: 15%;line-height: 40px' : ''">
                    {{ item.name }}</p>
            </li>
            <li @click="goIntroduce">
                <span><img src="../assets/img/teams/club.svg" alt=""></span>
                <p>俱乐部介绍</p>
            </li>
            <li @click="goSmartPitch">
                <span><img src="../assets/img/teams/smartPitch.svg" alt=""></span>
                <p>智慧球场</p>
            </li>
        </ul>

        <img class="exit" @click="exit" src="@/assets/img/common/quit.svg" alt="">
    </div>
</template>

<script>
export default {
    name: "teams",
    computed: {
        paramsCommandFn() {
            return this.$store.state.paramsCommand;
        },
    },
    data() {
        return {
            teamsList: []
        }
    },
    watch: {
        paramsCommandFn: {
            handler(val, old) {
                // let teams = ['成年队','青年队'];

                let teams = [];
                this.teamsList.map(item => {
                    teams.push({
                        value: item.name,
                        id: item.id,
                        name: item.name
                    })
                })
                teams.push({
                    value: '俱乐部介绍',
                    id: '1',
                    name: '俱乐部介绍'
                })
                teams.push({
                    value: '智慧球场',
                    id: '2',
                    name: '智慧球场'
                })
                let flag = 0;//是否触发
                for (let p = 0; p < teams.length; p++) {
                    if (eval('/' + teams[p].value + '/gi').test(val)) {
                        this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                        clearInterval(this.$parent.timer);
                        this.$parent.imgAi(this.$imgJson.taskAiImgArr);
                        if (p === teams.length - 2) {  // 介绍
                            this.$store.dispatch("setRouter", {path: '/introduce', name: 'introduce', goType: 1});//vuex改变路由
                        } else if (p === teams.length - 1) {  // 智慧球场
                            this.$store.dispatch("setRouter", {path: '/smartPitch', name: 'smartPitch', goType: 1});//vuex改变路由
                        } else {
                            this.$store.state.teamId = teams[p].id;
                            this.$store.state.teamName = teams[p].name + '_' + new Date().getTime();
                            this.$store.dispatch("setRouter", {path: '/about/main_btn', name: 'main_btn', goType: 1});//vuex改变路由
                        }
                        flag = 1;
                        return;
                    }
                }

                if (!flag) {
                    this.$parent.imgAi(this.$imgJson.taskAiImgArr);
                    this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息---好的
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getTeamList();
        let userName = this.$store.state.userName;
        let userTit = this.$store.state.userTit;
        this.$store.state.promptMsg = '队伍名称';
        this.$parent.audioPlayFn(this.$global.audioPlayUrl(userName + this.$global.randomFn(this.$aiJson.playVoice.opening)), true, true, 2);
    },
    methods: {
        getTeamList() {
            this.$server.getTeamList().then((res) => {
                this.teamsList = res.data;
            })
        },
        goMenu(item) {
            this.$store.state.teamId = item.id;
            this.$store.state.teamName = item.name + '_' + new Date().getTime();
            this.$store.dispatch("setRouter", {path: '/about/main_btn', name: 'main_btn', goType: 1});//vuex改变路由
            this.$router.push({path: '/about/main_btn', name: 'main_btn', goType: 1})
        },
        goIntroduce() {
            this.$store.dispatch("setRouter", {path: '/about/introduce', name: 'introduce', goType: 1});//vuex改变路由
            this.$router.push({path: '/about/introduce', name: 'introduce', goType: 1})
        },
        goSmartPitch() {
            this.$store.dispatch("setRouter", {path: '/about/smartPitch', name: 'smartPitch', goType: 1});//vuex改变路由
            this.$router.push({path: '/about/smartPitch', name: 'smartPitch', goType: 1})
        },
        exit() {
            console.log(111)
            this.$store.dispatch("setFlag", '3_' + new Date().getTime());//vuex改变识别信息
            this.$store.dispatch("setRouter", {path: '/', name: 'Home', goType: 1});//vuex改变路由
        }
    }
}
</script>

<style scoped lang="less">
.teams {
    width: 100%;
    padding-left: 2vw;

    .list {
        width: 100%;
        height: 88%;
        padding-top: 3%;
        margin-left: 10%;
        /*box-sizing: border-box;*/
    }

    li {
        text-align: center;
        float: left;
        height: 48%;
        width: 27%;
        margin-bottom: 7%;
        background-image: url("../assets/img/teams/bg.svg");
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: center;

        p {
            font-family: YouSheBiaoTiHei;
            background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 42px;
            line-height: 60px;
        }

        span {
            margin-top: 18%;
            width: 45%;
            display: inline-block;

            img {
                width: 100%;
            }
        }
    }
}
.exit {
    position: fixed;
    top: 3vw;
    right: 50px;
    width: 50px;
    z-index: 10000000;
}
</style>
